module.exports = __webpack_public_path__ + "img/bee_with_flower_white.002ef696.svg";